import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class AgeAnalysisLiabilityCriteria extends Model.CriteriaBase {
    static typeName = "AgeAnalysisLiabilityCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date = DateUtils.monthEnd(DateUtils.today());

    @Rules.Required()
    public entityId: number | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<AgeAnalysisLiabilityCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Age Analysis Liability Criteria";
    }
}